import { Component, } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidateUri } from 'src/app/validators/validate-uri';
import { takeUntil } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lex-upload-folder-dialog',
    templateUrl: './upload-folder-dialog.component.html',
    styleUrls: ['./upload-folder-dialog.component.scss'],
    standalone: false
})
export class UploadFolderDialogComponent extends BaseComponent {
  public uploadFormGroup: FormGroup;
  public folderPath: string;
  private fileServer: 'austin' | 'amazon' = 'austin';
  constructor(
    private dialogRef: MatDialogRef<UploadFolderDialogComponent>,
    private fb: FormBuilder,) {
    super();
    this.uploadFormGroup = this.fb.group({
      folderPath: [this.folderPath, [ValidateUri, Validators.required]],
      fileServer: [this.fileServer]
    });

    this.uploadFormGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((newValue) => {
      this.folderPath = newValue.folderPath;
      this.fileServer = newValue.fileServer;
    });
  }

  public ok(): void {
    this.dialogRef.close({
      path: this.folderPath,
      server: this.fileServer
    });
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }
}
